<template>
  <footer v-if="isVisible" class="app-debug">
    <p class="app-debug__title">Geräteinformationen</p>
    <p class="app-debug__user-agent">{{ userAgent }}</p>
  </footer>
</template>

<script>
const DEBUG_KEYS = ['t', 'c', 'l'];

export default {
  name: 'AppDebug',
  data() {
    return {
      isVisible: false,
      isShortcutActive: false,
      pressedKeys: new Set(),
      userAgent: 'Wird erkannt...',
    };
  },
  mounted() {
    this.updateUserAgent();
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
    window.addEventListener('blur', this.resetShortcut);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
    window.removeEventListener('blur', this.resetShortcut);
  },
  methods: {
    handleKeyDown(event) {
      this.updatePressedKeys(event.key, true);

      if (this.hasShortcutPressed() && !this.isShortcutActive) {
        this.isVisible = !this.isVisible;
        this.isShortcutActive = true;
      }
    },
    handleKeyUp(event) {
      this.updatePressedKeys(event.key, false);

      if (!this.hasShortcutPressed()) {
        this.isShortcutActive = false;
      }
    },
    resetShortcut() {
      this.pressedKeys = new Set();
      this.isShortcutActive = false;
    },
    updatePressedKeys(keyValue, isPressed) {
      const key = keyValue.toLowerCase();

      if (!DEBUG_KEYS.includes(key)) {
        return;
      }

      const pressedKeys = new Set(this.pressedKeys);

      if (isPressed) {
        pressedKeys.add(key);
      } else {
        pressedKeys.delete(key);
      }

      this.pressedKeys = pressedKeys;
    },
    hasShortcutPressed() {
      return DEBUG_KEYS.every((key) => this.pressedKeys.has(key));
    },
    updateUserAgent() {
      this.userAgent = window.navigator.userAgent || 'Unbekannt';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.app-debug {
  background-color: #fff;
  border-top: 1px solid rgba($grau_2, 0.15);
  color: $grau_2;
  flex-shrink: 0;
  font-size: 12px;
  line-height: 1.4;
  padding: 10px 20px;

  @media (min-width: $largeMobile) {
    padding-left: 40px;
    padding-right: 40px;
  }

  &__title {
    font-weight: 600;
    margin: 0 0 4px;
  }

  &__user-agent {
    margin: 0;
    overflow-wrap: anywhere;
  }
}
</style>
